export const ROUTES_TOP = [
    {
        path: "/",
        text: "Cлайды",
        openInNewTab: true,
    },
    {
        path: "/upload/",
        text: "Загрузка",
        openInNewTab: true,
    },
    // {
    //     path: "/organizations/",
    //     text: "Организации",
    // },
];

export const ROUTES_LEFT = [
    {
        path: "/export/",
        text: "Экспорт",
    },
];

export const MENU_LEFT = [
    {
        title: "О системе",
        content: "ECP PATO 1.0",
        isInfo: true
    },
]
